import { Component, EventEmitter } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-confirm-dialog-component',
    templateUrl: './confirm-dialog-component.component.html',
    styleUrls: ['./confirm-dialog-component.component.scss'],
    standalone: false
})
/* istanbul ignore next */
export class ConfirmDialogComponent {
  errorMessage: string | null = null;
  readonly confirmed = new EventEmitter<void>();

  constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>) {}

  onConfirm() {
    this.confirmed.emit();
  }
}
